import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// react-snap pre-renders each route to static HTML at build time. When the user's browser then
// loads the page, we MUST hydrate (not re-render) so the static markup is preserved — otherwise
// React would discard the SEO-friendly HTML before Google ever sees it.
const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}
